import { css, keyframes } from "@compiled/react";

import { ProductKeyTypes } from "@/libraries/wpl/foundations/src";

import { MobileNavWhyBitbucket } from "./mobile-nav-why-bitbucket";
import { DropdownType } from "./mobile-product-page-nav";

export type MobileProductPageNavDropdownsProps = {
    productKey: ProductKeyTypes;
    menuPage: DropdownType;
};

const slideInRight = keyframes({
    from: {
        transform: "translateX(100%)",
        opacity: "0"
    },
    to: {
        transform: "translateX(0%)",
        opacity: "1"
    }
});

const slideInRightCss = css({
    opacity: "0",
    animation: `0.5s ${slideInRight} forwards`
});

const shownInnerMobileDropdownMenuStyle = css({
    display: "block",
    margin: "8px 16px"
});

const hiddenInnerMobileDropdownMenuStyle = css({
    display: "none",
    margin: "8px 16px"
});

export const MobileBitbucketNavDropdownItems = ({
    menuPage,
    productKey
}: MobileProductPageNavDropdownsProps) => {
    return (
        <div
            css={[
                slideInRightCss,
                menuPage === "why-bitbucket"
                    ? shownInnerMobileDropdownMenuStyle
                    : hiddenInnerMobileDropdownMenuStyle
            ]}
            className="inner-mobile-dropdown-menu"
        >
            <MobileNavWhyBitbucket productKey={productKey} />
        </div>
    );
};

export const MobileProductPageNavDropdowns = ({
    productKey,
    menuPage
}: MobileProductPageNavDropdownsProps) => {
    return (
        <>
            {productKey === "bitbucket" && (
                <MobileBitbucketNavDropdownItems
                    productKey={productKey}
                    menuPage={menuPage}
                />
            )}
        </>
    );
};
